/**
 * Extracts the atlOrigin parameter from a URL string
 * @param url - The URL to extract atlOrigin from
 * @returns The atlOrigin value or empty string if not found
 */
export const extractAtlOriginFromUrl = (url: string): string => {
    try {
        const urlParams = new URLSearchParams(url.split("?")[1] || "");
        return urlParams.get("atlOrigin") || "";
    } catch {
        return "";
    }
};
